import { RouteModule } from '#/horizon/components/RouteModule';
import type { LoaderDataWithOverrideLocale } from '#/horizon/useMatchesOverrideLocale';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { salaryApiIsomorphicFetchCanSubmitSurvey } from '#/modules/salary/api/salaryApiFetchCanSubmitSurvey';
import {
  salariesExploreRoute,
  salariesSurveyRoute,
} from '#/modules/salary/routing/salary.routes';
import { HORIZON_ENABLED } from '#/rendering/state/renderingState';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { idealistRedirect } from '#/routing/utils/idealistRedirect';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import { SalarySurveyPageLoadable } from './SalarySurveyPageLoadable';

export const handle = {
  variant: 'base',
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof salariesSurveyRoute>) {
  if (!HORIZON_ENABLED) {
    await SalarySurveyPageLoadable.load();

    return {
      overrideLocale: I18nLocale.EN,
    } satisfies LoaderDataWithOverrideLocale;
  }

  const [canSubmitSurvey] = await Promise.all([
    salaryApiIsomorphicFetchCanSubmitSurvey({ request, context })().catch(
      () => false,
    ),
    SalarySurveyPageLoadable.load(),
  ]);

  if (!canSubmitSurvey) {
    return idealistRedirect({ request, context })(
      salariesExploreRoute.with({}),
      { flashMessage: { type: 'SURVEY_SUBMITTED_TOO_MANY_TIMES' } },
    );
  }

  return {
    overrideLocale: I18nLocale.EN,
  } satisfies LoaderDataWithOverrideLocale;
}

export default function SalarySurveyHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return (
    <RouteModule
      title="Idealist"
      ogImage={getStaticImageSrc('compdb/og-image.png')}
    >
      <SalarySurveyPageLoadable />
    </RouteModule>
  );
}
